import { Box, Typography } from '@mui/material'
import logo from '../../logo.png'

export interface ReferralExpiredViewProps {
  message?: string
}

export const ReferralExpiredView = ({
  message = 'It may have already been completed. Please check your inbox for a new verification email.',
}: ReferralExpiredViewProps): JSX.Element => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap={3}
      textAlign="center"
    >
      <Box
        component="img"
        src={logo}
        alt="resolvexLogo"
        sx={{ width: { xs: 100, sm: 152 } }}
      />
      <Typography
        variant="h4"
        color="primary.main"
        fontWeight={600}
        sx={{ fontSize: { xs: '1.5rem', sm: '2.125rem' } }}
      >
        This verification link is no longer valid.
      </Typography>
      <Typography variant="body1" color="text.disabled">
        {message}
      </Typography>
    </Box>
  )
}
